export const items = [
  {
    id: 'razorpay',
    icon: 'razorPayX.png',
    title: 'RazorpayX Payroll',
    subtitle: 'Payroll Software',
    details: `Manage payroll, attendance, reimbursements, and compliances, all on a single dashboard. Automate payroll & compliances like PF, TDS, ESI & PT for your business in 10 minutes.`
  },
  {
    id: 'greenhouse',
    icon: 'greenhouse.png',
    title: 'Greenhouse',
    subtitle: 'Applicant Tracking System',
    details: `An easy, automated way to engage with talent sourcing automation helps hiring teams find, reach and engage top talent quickly and effectively.`
  },
  {
    id: 'lever',
    icon: 'lever.png',
    title: 'Lever',
    subtitle: 'Applicant Tracking System',
    details: `Lever is a leading talent acquisition suite that makes it easy for talent teams to reach their hiring goals and to connect companies with top talent.`
  },
  {
    id: 'zoho-recruit',
    icon: 'zoho_recruit.png',
    title: 'Zoho Recruit',
    subtitle: 'Recruitment Software',
    details:
      'Zoho Recruit is a comprehensive recruitment platform that helps streamline your hiring process. It offers features like candidate sourcing, resume management, and interview scheduling.'
  },
  {
    id: 'recruitee',
    icon: 'recruitee.png',
    title: 'Recruitee',
    subtitle: 'Applicant Tracking System',
    details: `Recruitee is built for bringing teams together. More than 5,000 companies use our collaborative hiring software to share the work, speed up daily processes, and grow their teams together.`
  },
  {
    id: 'keka',
    icon: 'keka.png',
    title: 'Keka HR',
    subtitle: 'HRMS Software',
    details:
      'Keka HR is an end-to-end employee experience platform that automates HR management for businesses. It offers solutions for payroll, attendance, performance, and more.'
  },
  {
    id: 'freshworks',
    icon: 'freshworks.png',
    title: 'FreshTeam by Freshworks',
    subtitle: 'HRMS Software',
    details:
      'FreshTeam is a smart HR management system that helps businesses manage their teams efficiently. It offers features like time-off management, employee information system, and more.freshteam.'
  },
  {
    id: 'scrut',
    icon: 'scrut.jpg',
    title: 'Scrut Automation',
    subtitle: 'Compliance Automation Software',
    details:
      'Scrut Automation offers a platform for continuous risk assessment and monitoring. It helps businesses build unique risk-first infosec programs and manage multiple compliance audits.'
  },
  {
    id: 'sprinto',
    icon: 'sprinto.png',
    title: 'Sprinto',
    subtitle: 'Security Compliance Automation Platform',
    details:
      'Sprinto is a security compliance automation platform that helps businesses automate their risk assessment and monitoring. It offers features like real-time risk monitoring, collaborative workflows, and deep integrations.'
  },
  {
    id: 'rippling',
    icon: 'rippling.png',
    title: 'Rippling',
    subtitle: 'Workforce Management Platform',
    details:
      'Rippling is a platform that simplifies managing your employees payroll, benefits, expenses, and more. It is designed to help you easily scale from 2 to 2,000+ employees.'
  },
  {
    id: 'inkle',
    icon: 'inkle.jpg',
    title: 'Inkle',
    subtitle: 'CPA and Compliance Software',
    details:
      'Inkle is a chat-based CPA platform used by hundreds of US cross-border companies for books, tax, and compliance. It offers an all-in-one SaaS stack for founders to access affordable, quality, US-licensed Certified Public Accountant services'
  }
];
